module.exports = __webpack_public_path__ + "0ae65dcfc24b98935b77ebef534d6e11.svg";